import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import { Card, Grid, Typography, Chip, IconButton, Box, Tooltip, Button } from '@mui/material';

import Avatar from 'src/components/extended/Avatar'
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Profile from 'src/components/account-profile/Profile1';
import DialogTitle from '@mui/material/DialogTitle';
const avatarImage = require.context('src/assets/images/users', true);
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import EmployeeCard from 'src/components/cards/EmployeeCard';
import Slide from '@mui/material/Slide';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

// ==============================|| USER DETAILS CARD ||============================== //

const UserDetailsCard = ({ about, avatar, contact, email, location, name, role, status, id, OrganizationTypeId, serviceShopId, StatusId, NameParam, SurnameParam, DealerGroup, PersonelKocAilemStatus }) => {
  const theme = useTheme();
  // const avatarProfile = avatar && avatarImage(`./${avatar}`);

  const [gridSpacing, setgridSpacing] = useState(1);
  const [openEditPopUp, setOpenEditPopUp] = useState(false);
  const [OpenShowPopUp, setOpenShowPopUp] = useState(false);


  return (
    <Card
      sx={{
        position: 'relative',
        overflow: 'visible',
        p: 2.5,
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
        border: theme.palette.mode === 'dark' ? '1px solid transparent' : `2px solid${theme.palette.grey[100]}`,
        '&:hover': {
          borderColor: theme.palette.primary.main,
          transform: 'translateY(-2px)',
          boxShadow: '0 14px 34px rgba(15, 23, 42, 0.10)'
        }
      }}

    >
      <Grid container spacing={gridSpacing} style={{ minHeight: 320 }}>
        <Grid size={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Avatar alt={name} size="lg" src={avatar}
              style={{
                width: theme.spacing(6),
                height: theme.spacing(6),

              }}
            />
            {status === "Aktif" ? (
              <Chip
                label="Aktif"
                size="small"
                sx={{ bgcolor: 'success.main', color: 'success.contrastText' }}
              />
            ) : (
              <Chip
                label="Pasif"
                size="small"
                sx={{ bgcolor: 'error.main', color: 'error.contrastText' }}
              />
            )}
          </Box>
        </Grid>
        <Grid size={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h4" component="div" noWrap title={name} sx={{ minWidth: 0 }}>
              {name}
            </Typography>
          </Box>
          <Typography variant="caption">{role}</Typography>
        </Grid>
        <Grid size={12}>
          <Typography
            variant="subtitle2"
            sx={{
              color: theme.palette.grey[700],
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
            title={about}
          >
            {about || '—'}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography variant="caption">Email</Typography>
          <Typography variant="h6" noWrap title={email}>{email || '—'}</Typography>
        </Grid>
        <Grid size={12}>
          <Grid container spacing={gridSpacing}>
            <Grid size={6}>
              <Typography variant="caption">Telefon</Typography>
              <Typography variant="h6" noWrap title={contact}>{contact || '—'}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="caption">Şehir</Typography>
              <Typography variant="h6" noWrap title={location}>{location || '—'}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12}>
          <Grid container spacing={1}>
            <Grid size={6}>
              <Button
                variant="contained"
                fullWidth
                disableElevation
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  bgcolor: alpha(theme.palette.primary.main, 0.12),
                  color: 'primary.main',
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: '#fff',
                    boxShadow: 'none'
                  }
                }}
                startIcon={<EditTwoToneIcon />}
                onClick={() => setOpenEditPopUp(true)}>
                Düzenle
              </Button>

            </Grid>
            <Grid size={6}>
              <Button
                variant="contained"
                fullWidth
                disableElevation
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  bgcolor: alpha(theme.palette.text.primary, 0.08),
                  color: 'text.primary',
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: theme.palette.grey[800],
                    color: '#fff',
                    boxShadow: 'none'
                  }
                }}
                onClick={() => setOpenShowPopUp(true)}
                startIcon={<VisibilityTwoToneIcon />}>
                Göster
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={openEditPopUp}
        maxWidth="xl"
        fullWidth
        TransitionComponent={Slide} // Slide geçiş efekti için TransitionComponent olarak Slide'ı kullanıyoruz
        TransitionProps={{
          direction: 'up', // Dialogun sağdan sola açılmasını sağlamak için direction prop'unu 'left' olarak belirliyoruz
        }}
        sx={{ '& .MuiDialog-paper': { height: '90vh', maxHeight: '90vh' } }}
        onClose={() => setOpenEditPopUp(false)}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          Çalışan Detayı
          <IconButton
            edge="end"
            size="small"
            color="inherit"
            onClick={() => setOpenEditPopUp(false)}
            aria-label="close"
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Profile EmployeeNr={id}
            OrganizationTypeId={OrganizationTypeId}
            ServiceShopId={serviceShopId}
            // Kvkk={Kvkk}
            // KvkkPhone={KvkkPhone}
            // KvkkEmail={KvkkEmail}
            Name={NameParam}
            Surname={SurnameParam}
            PersonelType={role}
            StateId={StatusId} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={OpenShowPopUp}
        onClose={() => setOpenShowPopUp(false)}

      >
        <EmployeeCard EmployeeNr={id} EmployeeName={name} EmployeeRole={role} EmployeeDealerGroup={DealerGroup} />
        <DialogActions>
          <Button onClick={() => setOpenShowPopUp(false)} autoFocus>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

UserDetailsCard.propTypes = {
  about: PropTypes.string,
  avatar: PropTypes.string,
  contact: PropTypes.string,
  email: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.number,
  OrganizationTypeId: PropTypes.number,
  serviceShopId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  StatusId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  NameParam: PropTypes.string,
  SurnameParam: PropTypes.string,
  DealerGroup: PropTypes.string,
  PersonelKocAilemStatus: PropTypes.number,
};

export default UserDetailsCard;
